__turbopack_context__.v({
  "className": "jetbrains_mono_416253e6-module__UDbJ4a__className",
  "variable": "jetbrains_mono_416253e6-module__UDbJ4a__variable",
});
